import { type defineComponent } from "vue";

import { getAsyncComponent } from "@/hooks/common";

import type { WorkflowBlockIds } from "@/models/workflows";

const AccountsPayable = getAsyncComponent(
  () => import("@/components/deals/AccountsPayable.vue")
);
const AdditionalAffiliatedBusinessInfo = getAsyncComponent(
  () => import("@/views/deals/components/AdditionalAffiliatedBusinessInfo.vue")
);
const AdditionalBusinessInfo = getAsyncComponent(
  () => import("@/views/deals/components/AdditionalBusinessInfo.vue")
);
const AdditionalInfoBlock = getAsyncComponent(
  () => import("@/components/deals/AdditionalOwnerInfo.vue")
);
const AffiliatedBusinessInfo = getAsyncComponent(
  () => import("@/views/deals/components/AffiliatedBusinessInfo.vue")
);
const AffiliatedIndividuals = getAsyncComponent(
  () => import("@/views/deals/components/AffiliatedIndividuals.vue")
);
const AffiliatedIndividualsAdditionalInformation = getAsyncComponent(
  () =>
    import(
      "@/views/deals/components/AffiliatedIndividualsAdditionalInformation.vue"
    )
);
const BankAccountDetails = getAsyncComponent(
  () => import("@/views/deals/components/BankAccountDetails.vue")
);
const BondingAgentCard = getAsyncComponent(
  () => import("@/views/deals/components/BondingAgentCard.vue")
);
const BusinessNotes = getAsyncComponent(
  () => import("@/views/deals/components/BusinessNotes.vue")
);
const BusinessTaxReturn = getAsyncComponent(
  () => import("@/views/deals/components/BusinessTaxReturn.vue")
);
const ClearAdverseMedia = getAsyncComponent(
  () => import("@/components/deals/dataServices/adverseMedia/Clear.vue")
);
const ClearBankrupctyPerson = getAsyncComponent(
  () =>
    import(
      "@/components/deals/dataServices/ClearBankruptcy/ClearBankruptcyPerson.vue"
    )
);
const ClearBusiness = getAsyncComponent(
  () => import("@/components/deals/dataServices/liens/ClearBusiness.vue")
);
const ClearBusinessLiens = getAsyncComponent(
  () => import("@/components/deals/dataServices/liens/ClearBusiness.vue")
);
const ClearBusinessLitigation = getAsyncComponent(
  () =>
    import(
      "@/components/deals/dataServices/litigation/clear/LitigationBusiness.vue"
    )
);
const ClearBusinessUccs = getAsyncComponent(
  () => import("@/components/deals/dataServices/ClearBusiness.vue")
);
const ClearCourtSearch = getAsyncComponent(
  () => import("@/components/deals/dataServices/litigation/CourtSearch.vue")
);
const ClearIndividualLitigation = getAsyncComponent(
  () =>
    import(
      "@/components/deals/dataServices/litigation/clear/LitigationIndividual.vue"
    )
);
const ClearIndividualUccs = getAsyncComponent(
  () => import("@/components/deals/dataServices/ucc/Clear.vue")
);
const ClearKyb = getAsyncComponent(
  () => import("@/components/deals/dataServices/kyb/ClearKyb.vue")
);
const ClearKyc = getAsyncComponent(
  () => import("@/components/deals/dataServices/kyc/ClearKyc.vue")
);
const ClearLiens = getAsyncComponent(
  () => import("@/components/deals/dataServices/liens/ClearLiens.vue")
);
const ClosingOffers = getAsyncComponent(
  () => import("@/views/deals/components/ClosingOffers.vue")
);
const Codat = getAsyncComponent(
  () => import("@/views/deals/components/Codat.vue")
);
const CompanyDebts = getAsyncComponent(
  () => import("@/views/deals/components/CompanyDebts.vue")
);
const CompanyOfficers = getAsyncComponent(
  () => import("@/views/deals/components/CompanyOfficers.vue")
);
const CustomAttributes = getAsyncComponent(
  () => import("@/views/deals/components/customAttributes/CustomAttributes.vue")
);
const CustomerInformation = getAsyncComponent(
  () => import("@/views/deals/components/CustomerInformation.vue")
);
const DiscoveryQuestions = getAsyncComponent(
  () => import("@/views/deals/activity/DiscoveryCallQuestions.vue")
);
const DnBBusinessCredit = getAsyncComponent(
  () => import("@/components/deals/dataServices/Dnb.vue")
);
const DnBBusinessMatch = getAsyncComponent(
  () => import("@/components/deals/dataServices/matchDnb/MatchDnb.vue")
);
const DnBCompanyInformation = getAsyncComponent(
  () =>
    import("@/components/deals/dataServices/kyb/dnb/DnBCompanyInformation.vue")
);
const Ekata = getAsyncComponent(
  () => import("@/views/deals/components/Ekata.vue")
);
const EquipmentDetails = getAsyncComponent(
  () => import("@/views/deals/components/EquipmentDetails.vue")
);
const Equifax = getAsyncComponent(
  () =>
    import("@/components/deals/dataServices/personalCredit/equifax/Equifax.vue")
);
const ExperianBankruptcies = getAsyncComponent(
  () => import("@/components/deals/dataServices/bankruptcies/Experian.vue")
);
const ExperianBusinessCredit = getAsyncComponent(
  () => import("@/components/deals/dataServices/experian/ExperianBC.vue")
);
const ExperianBusinessMatch = getAsyncComponent(
  () =>
    import("@/components/deals/dataServices/matchExperian/MatchExperian.vue")
);
const ExperianQuickSearch = getAsyncComponent(
  () =>
    import(
      "@/components/deals/dataServices/matchExperian/ExperianQuickSearchWrapper.vue"
    )
);
const ExperianGdn = getAsyncComponent(
  () => import("@/components/deals/dataServices/experian/ExperianGDN.vue")
);
const ExperianJudgments = getAsyncComponent(
  () =>
    import("@/components/deals/dataServices/judgments/experian/Experian.vue")
);
const ExperianFacts = getAsyncComponent(
  () => import("@/components/deals/dataServices/experian/kyb/ExperianFacts.vue")
);
const ExperianLiens = getAsyncComponent(
  () => import("@/components/deals/dataServices/liens/ExperianLiens.vue")
);
const ExperianPersonalCredit = getAsyncComponent(
  () =>
    import(
      "@/components/deals/dataServices/experian/ExperianPersonalCredit.vue"
    )
);
const ExperianUccs = getAsyncComponent(
  () => import("@/components/deals/dataServices/ucc/Experian.vue")
);
const ExperianBusinessContacts = getAsyncComponent(
  () =>
    import(
      "@/components/deals/dataServices/experian/kyb/ExperianBusinessContacts.vue"
    )
);
const ExperianCorporateRegistrations = getAsyncComponent(
  () =>
    import(
      "@/components/deals/dataServices/experian/kyb/ExperianCorporateRegistrations.vue"
    )
);
const ExperianLegalCollections = getAsyncComponent(
  () =>
    import(
      "@/components/deals/dataServices/experian/kyb/ExperianLegalCollections.vue"
    )
);
const ExperianCommercialCollections = getAsyncComponent(
  () =>
    import("@/components/deals/dataServices/experian/CommercialCollections.vue")
);
const ExperianCreditStatus = getAsyncComponent(
  () => import("@/components/deals/dataServices/experian/CreditStatus.vue")
);
const FraudSentilink = getAsyncComponent(
  () => import("@/views/deals/components/FraudSentilink.vue")
);
const FundingDetails = getAsyncComponent(
  () => import("@/components/deals/workflow/CompletedStage/FundingDetails.vue")
);
const FundingInfo = getAsyncComponent(
  () => import("@/components/FundingInfo.vue")
);
const FundingSummary = getAsyncComponent(
  () => import("@/components/deals/workflow/CompletedStage/FundingSummary.vue")
);
const Guarantor = getAsyncComponent(
  () => import("@/views/deals/components/equipmentRental/GuarantyCard.vue")
);
const Inscribe = getAsyncComponent(
  () => import("@/components/deals/dataServices/Inscribe.vue")
);
const InsuranceInformation = getAsyncComponent(
  () => import("@/views/deals/components/InsuranceInformation.vue")
);
const LexisNexisBankruptcy = getAsyncComponent(
  () =>
    import(
      "@/components/deals/dataServices/bankruptcies/lexisNexis/LexisNexis.vue"
    )
);
const LexisNexisJudgments = getAsyncComponent(
  () =>
    import(
      "@/components/deals/dataServices/judgments/lexisNexis/LexisNexis.vue"
    )
);
const LexisNexisKyb = getAsyncComponent(
  () => import("@/components/deals/dataServices/kyb/LexisNexis.vue")
);
const LexisNexisKyc = getAsyncComponent(
  () => import("@/components/deals/dataServices/kyc/lexisNexis/LexisNexis.vue")
);
const LexisNexisLiens = getAsyncComponent(
  () => import("@/components/deals/dataServices/liens/LexisNexisLiens.vue")
);
const LexisNexisUccs = getAsyncComponent(
  () => import("@/views/deals/uccs/LexisNexisUcc.vue")
);
const LoanServicing = getAsyncComponent(
  () => import("@/components/deals/closing/SubmitToServicer.vue")
);
const MatchClearBusiness = getAsyncComponent(
  () =>
    import(
      "@/components/deals/dataServices/matchClear/business/MatchClearBusiness.vue"
    )
);
const MatchClearIndividual = getAsyncComponent(
  () =>
    import(
      "@/components/deals/dataServices/matchClear/individual/MatchClearIndividual.vue"
    )
);
const MatchSentilink = getAsyncComponent(
  () =>
    import("@/components/deals/dataServices/matchSentilink/MatchSentilink.vue")
);
const MiddeskBankruptcy = getAsyncComponent(
  () => import("@/components/deals/dataServices/bankruptcies/Middesk.vue")
);
const MiddeskKyb = getAsyncComponent(
  () => import("@/components/deals/dataServices/kyb/Middesk.vue")
);
const Ocrolus = getAsyncComponent(
  () => import("@/components/deals/dataServices/cfa/ocrolus/Ocrolus.vue")
);
const OfferDetails = getAsyncComponent(
  () => import("@/components/deals/workflow/CompletedStage/OfferDetails.vue")
);
const Persona = getAsyncComponent(
  () => import("@/components/deals/dataServices/Persona.vue")
);
const PersonalInfo = getAsyncComponent(
  () => import("@/views/deals/components/OwnersPersonalInfo.vue")
);
const PersonalTaxReturn = getAsyncComponent(
  () => import("@/views/deals/components/PersonalTaxReturn.vue")
);
const Plaid = getAsyncComponent(
  () => import("@/views/deals/components/bankData/Plaid.vue")
);
const PrismData = getAsyncComponent(
  () =>
    import("@/components/deals/dataServices/cfa/prism/PrismDataJsonViewer.vue")
);
const PrequalDetails = getAsyncComponent(
  () => import("@/views/deals/components/PrequalDetails.vue")
);
const PrimaryBusiness = getAsyncComponent(
  () => import("@/views/deals/components/PrimaryBusinessInfo.vue")
);
const SignedDealsParent = getAsyncComponent(
  () => import("@/views/deals/components/SignedDealsParent.vue")
);
const Spinwheel = getAsyncComponent(
  () =>
    import(
      "@/components/deals/dataServices/personalCredit/spinwheel/Spinwheel.vue"
    )
);
const SocureFraud = getAsyncComponent(
  () => import("@/views/deals/components/SocureFraud.vue")
);
const SocureKYC = getAsyncComponent(
  () => import("@/views/deals/components/Socure.vue")
);
const StipsCollection = getAsyncComponent(
  () => import("@/views/deals/components/StipsCollection.vue")
);
const CheckoutBlock = getAsyncComponent(
  () => import("@/components/deals/workflow/Checkout/CheckoutBlock.vue")
);
const TradeReferences = getAsyncComponent(
  () =>
    import("@/views/deals/components/equipmentRental/TradeReferencesCard.vue")
);
const BusinessTransportationInformation = getAsyncComponent(
  () => import("@/views/deals/components/BusinessTransportationInformation.vue")
);

const MoneyThumb = getAsyncComponent(
  () =>
    import(
      "@/components/deals/dataServices/cfa/moneythumb/MoneyThumbService.vue"
    )
);

const BluCognition = getAsyncComponent(
  () =>
    import(
      "@/components/deals/dataServices/documentVerification/BluCognition.vue"
    )
);

const TaxStatusKyb = getAsyncComponent(
  () => import("@/components/deals/dataServices/kyb/taxStatus/TaxStatusKyb.vue")
);

const TaxStatusKyc = getAsyncComponent(
  () => import("@/components/deals/dataServices/kyc/taxStatus/TaxStatusKyc.vue")
);

const MiddeskBusinessMatch = getAsyncComponent(
  () =>
    import(
      "@/components/deals/dataServices/businessMatch/middesk/MiddeskBusinessMatch.vue"
    )
);

const EnigmaBusinessMatch = getAsyncComponent(
  () =>
    import(
      "@/components/deals/dataServices/businessMatch/enigma/EnigmaBusinessMatch.vue"
    )
);

const ExperianFraud = getAsyncComponent(
  () =>
    import("@/components/deals/dataServices/experian/fraud/ExperianFraud.vue")
);

const TransUnionPersonalCredit = getAsyncComponent(
  () =>
    import(
      "@/components/deals/dataServices/personalCredit/transunion/TransUnion.vue"
    )
);

const LexisNexisBusinessCredit = getAsyncComponent(
  () =>
    import(
      "@/components/deals/dataServices/businessCredit/lexisNexis/LexisNexis.vue"
    )
);

const EnigmaKyb = getAsyncComponent(
  () => import("@/components/deals/dataServices/kyb/enigma/EnigmaKyb.vue")
);

const LexisNexisContactCard = getAsyncComponent(
  () =>
    import(
      "@/components/deals/dataServices/kyb/lexisNexisContactCard/LexisNexisContactCard.vue"
    )
);

const LexisNexisEmailSearch = getAsyncComponent(
  () =>
    import(
      "@/components/deals/dataServices/kyc/lexisNexis/emailSearch/LexisNexisEmailSearch.vue"
    )
);

const MiddeskLiens = getAsyncComponent(
  () => import("@/components/deals/dataServices/liens/middesk/MiddeskLiens.vue")
);

const LexisNexisRiskView = getAsyncComponent(
  () =>
    import(
      "@/components/deals/dataServices/personalCredit/lexisNexis/riskView/LexisNexisRiskView.vue"
    )
);

const Numverify = getAsyncComponent(
  () =>
    import("@/components/deals/dataServices/phoneVerification/Numverify.vue")
);

const FmcsaService = getAsyncComponent(
  () => import("@/components/deals/dataServices/kyb/fmcsa/FmcsaService.vue")
);

const Bbb = getAsyncComponent(
  () => import("@/components/deals/dataServices/kyb/bbb/Bbb.vue")
);

const Gbp = getAsyncComponent(
  () => import("@/components/deals/dataServices/kyb/gbp/Gbp.vue")
);

const Manta = getAsyncComponent(
  () => import("@/components/deals/dataServices/kyb/manta/Manta.vue")
);

const YellowPages = getAsyncComponent(
  () =>
    import("@/components/deals/dataServices/kyb/yellowPages/YellowPages.vue")
);

const Yelp = getAsyncComponent(
  () => import("@/components/deals/dataServices/kyb/yelp/Yelp.vue")
);

const EquifaxKyb = getAsyncComponent(
  () => import("@/components/deals/dataServices/kyb/equifax/EquifaxKyb.vue")
);

const VouchedJsonViewer = getAsyncComponent(
  () =>
    import("@/components/deals/dataServices/kyc/vouched/VouchedJsonViewer.vue")
);

const EnrichAiMatch = getAsyncComponent(
  () =>
    import(
      "@/components/deals/dataServices/businessMatch/enrichAi/EnrichAiMatch.vue"
    )
);

const BaseLayer = getAsyncComponent(
  () => import("@/components/deals/dataServices/kyb/baselayer/BaseLayer.vue")
);

const DataMerch = getAsyncComponent(
  () => import("@/components/deals/dataServices/kyb/dataMerch/DataMerch.vue")
);

const FourSquare = getAsyncComponent(
  () => import("@/components/deals/dataServices/kyb/foursquare/FourSquare.vue")
);

const TripAdvisor = getAsyncComponent(
  () =>
    import("@/components/deals/dataServices/kyb/tripadvisor/TripAdvisor.vue")
);

const DataExtraction = getAsyncComponent(
  () =>
    import("@/components/deals/dataServices/dataExtraction/DataExtraction.vue")
);

const EquifaxSbfeReport = getAsyncComponent(
  () =>
    import("@/components/deals/dataServices/kyb/equifax/report/SbfeReport.vue")
);

const EquifaxCfnReport = getAsyncComponent(
  () =>
    import("@/components/deals/dataServices/kyb/equifax/report/CfnReport.vue")
);

const TwilioLookup = getAsyncComponent(
  () => import("@/components/deals/dataServices/phoneVerification/Twilio.vue")
);

const Trychart = getAsyncComponent(
  () =>
    import(
      "@/components/deals/dataServices/taxInformation/Trychart/Trychart.vue"
    )
);

const DebtSchedule = getAsyncComponent(
  () => import("@/views/deals/components/applicationStage/DebtSchedule.vue")
);

export type WorkflowBlockComponentsKey = Exclude<
  WorkflowBlockIds,
  | "bank_account_data"
  | "bank_data"
  | "business_extra"
  | "middesk"
  | "monthly_balance"
  | "transactions"
>;
// Please keep the keys sorted alphabetically
const WORKFLOW_BLOCK_COMPONENTS: Record<
  WorkflowBlockComponentsKey,
  ReturnType<typeof getAsyncComponent> | ReturnType<typeof defineComponent>
> = {
  //Application
  accounts_payable: AccountsPayable,
  additional_business: AdditionalBusinessInfo,
  additional_owner: AdditionalInfoBlock,
  affiliated_businesses: AffiliatedBusinessInfo,
  affiliated_businesses_additional_information:
    AdditionalAffiliatedBusinessInfo,
  affiliated_individuals: AffiliatedIndividuals,
  affiliated_individuals_additional_information:
    AffiliatedIndividualsAdditionalInformation,
  bank_account_details: BankAccountDetails,
  bank_data_moneythumb: MoneyThumb,
  bank_data_ocrolus: Ocrolus,
  bank_data_plaid: Plaid,
  bonding_agent: BondingAgentCard,
  business: PrimaryBusiness,
  business_notes: BusinessNotes,
  company_debts: CompanyDebts,
  company_officers: CompanyOfficers,
  custom_attributes: CustomAttributes,
  customer_information: CustomerInformation,
  discovery: DiscoveryQuestions,
  equipment_details: EquipmentDetails,
  funding: FundingInfo,
  guarantor: Guarantor,
  insurance: InsuranceInformation,
  personal: PersonalInfo,
  personal_tax_return_information: PersonalTaxReturn,
  prequal: PrequalDetails,
  signed_application: SignedDealsParent,
  trade_references: TradeReferences,
  business_transportation_information: BusinessTransportationInformation,
  arsen_ai_enrich_match: EnrichAiMatch,
  business_debt_schedule: DebtSchedule,
  personal_debt_schedule: DebtSchedule,
  business_tax_return_information: BusinessTaxReturn,

  //Underwriting
  baselayer_kyb: BaseLayer,
  bbb_kyb: Bbb,
  blu_cognition: BluCognition,
  clear_adverse_media: ClearAdverseMedia,
  clear_bankruptcies: ClearBankrupctyPerson,
  clear_business_litigation: ClearBusinessLitigation,
  clear_business_match: MatchClearBusiness,
  clear_business_uccs: ClearBusinessUccs,
  clear_court_search: ClearCourtSearch,
  clear_individual_litigation: ClearIndividualLitigation,
  clear_individual_match: MatchClearIndividual,
  clear_individual_uccs: ClearIndividualUccs,
  clear_kyb: ClearKyb,
  clear_kyc: ClearKyc,
  clear_liens: ClearBusinessLiens,
  clear_liens_business: ClearBusiness,
  clear_liens_individual: ClearLiens,
  codat: Codat,
  data_merch_kyb: DataMerch,
  document_data_extraction: DataExtraction,
  dnb_business_credit: DnBBusinessCredit,
  dnb_business_match: DnBBusinessMatch,
  dnb_company_information_kyb: DnBCompanyInformation,
  ekata: Ekata,
  enigma_business_match: EnigmaBusinessMatch,
  enigma_kyb: EnigmaKyb,
  equifax_business_credit: Equifax,
  equifax_cfn_report_business_credit: EquifaxCfnReport,
  equifax_kyb: EquifaxKyb,
  equifax_sbfe_report_business_credit: EquifaxSbfeReport,
  experian_business_contacts: ExperianBusinessContacts,
  experian_corporate_registrations: ExperianCorporateRegistrations,
  experian_legal_collections: ExperianLegalCollections,
  experian_bankruptcies: ExperianBankruptcies,
  experian_business_credit: ExperianBusinessCredit,
  experian_business_match: ExperianBusinessMatch,
  experian_business_quick_search: ExperianQuickSearch,
  experian_gdn_business_credit: ExperianGdn,
  experian_judgments: ExperianJudgments,
  experian_kyb: ExperianFacts,
  experian_liens: ExperianLiens,
  experian_personal_credit: ExperianPersonalCredit,
  experian_uccs: ExperianUccs,
  experian_commercial_collections: ExperianCommercialCollections,
  experian_credit_status: ExperianCreditStatus,
  experian_fraud: ExperianFraud,
  fmcsa_kyb: FmcsaService,
  foursquare_kyb: FourSquare,
  gbp_kyb: Gbp,
  inscribe: Inscribe,
  lexis_nexis_business_credit: LexisNexisBusinessCredit,
  lexisnexis_bankruptcies: LexisNexisBankruptcy,
  lexisnexis_contact_card_report: LexisNexisContactCard,
  lexisnexis_email_search: LexisNexisEmailSearch,
  lexisnexis_judgments: LexisNexisJudgments,
  lexisnexis_kyb: LexisNexisKyb,
  lexisnexis_kyc: LexisNexisKyc,
  lexisnexis_liens: LexisNexisLiens,
  lexisnexis_personal_credit: LexisNexisRiskView,
  lexisnexis_uccs: LexisNexisUccs,
  manta_kyb: Manta,
  middesk_bankruptcies: MiddeskBankruptcy,
  middesk_business_search: MiddeskBusinessMatch,
  middesk_kyb: MiddeskKyb,
  middesk_liens: MiddeskLiens,
  moneythumb: MoneyThumb,
  numverify: Numverify,
  ocrolus: Ocrolus,
  ocrolus_doc_verification: Ocrolus,
  persona: Persona,
  plaid: Plaid,
  prismdata: PrismData,
  sentilink_fraud: FraudSentilink,
  sentilink_match: MatchSentilink,
  spinwheel_personal_credit: Spinwheel,
  socure_fraud: SocureFraud,
  socure_kyc: SocureKYC,
  tax_status_kyb: TaxStatusKyb,
  tax_status_kyc: TaxStatusKyc,
  transunion_personal_credit: TransUnionPersonalCredit,
  tripadvisor_kyb: TripAdvisor,
  try_chart_tax_data: Trychart,
  twilio_lookup: TwilioLookup,
  vouched: VouchedJsonViewer,
  yellow_pages_kyb: YellowPages,
  yelp_kyb: Yelp,

  //Closing
  loan_servicing: LoanServicing,
  offers: ClosingOffers,
  stips: StipsCollection,
  checkout: CheckoutBlock,

  //Funded
  funding_details: FundingDetails,
  funding_summary: FundingSummary,
  offer_details: OfferDetails,
};

export default WORKFLOW_BLOCK_COMPONENTS;
